<template>
    <template v-for="team in ArrangedMikomi" :key="team">
        <div class="EstimationsTeamEntry" style="display: flex;">
            <template v-for="month in team.Data" :key="month">
                <template v-if="team.Name === 'トイホビー'">
                    <Mikomi_Month v-if="IsFiltered(month)" :TeamFilter="TeamFilter" :MikomiMonthData="month" :CurrentMonth="CurrentMonth" />
                </template>
                <template v-else-if="team.Name === 'ゲーム開発'">
                    <Mikomi_Month_Game v-if="IsFiltered(month)" :Team="team.Name" :MikomiMonthData="month" :CurrentMonth="CurrentMonth" />
                </template>
                <template v-else>
                    <Mikomi_Month_Other v-if="IsFiltered(month)" :Team="team.Name" :MikomiMonthData="month" :CurrentMonth="CurrentMonth" />
                </template>
            </template>
        </div>
    </template>
</template>

<script>
import Mikomi_Month from './Mikomi_Month.vue';
import Mikomi_Month_Other from './Mikomi_Month_Other.vue';
import MikomiKeikaku from '@/classes/MikomiKeikaku';
import MikomiMonth from '@/classes/MikomiMonth';
import MikomiTeam from '@/classes/MikomiTeam';
import MikomiData from '@/classes/MikomiData';
import Mikomi_Month_Game from './Mikomi_Month_Game.vue';

export default{
    components:{
        Mikomi_Month,
        Mikomi_Month_Game,
        Mikomi_Month_Other
    },
    computed:{
        
    },
    props:{
        Mikomi: Array,
        FilteredTimeLine: Array,
        MikomiCreationDate: Date,
        TeamFilter: Array,
    },
    watch:{
        Mikomi: {
            handler()
            {
                if (this.IsCreatingMikomi === false)
                {
                    this.CreateArrangedMikomi();
                }
            },
            deep: true,
        }
    },
    mounted(){
        this.CreateArrangedMikomi();
    },
    methods:{
        CreateArrangedMikomi()
        {
            this.IsCreatingMikomi = true;
            //this.CurrentMonth = new Date().getMonth() + 1;
            this.CurrentMonth = this.MikomiCreationDate.getMonth() + 1;
            // console.log('[MikomiContainer] Mikomi creation date', this.CurrentMonth);

            // console.log('[MikomiContainer] FilteredTimeLine', this.FilteredTimeLine);
            // console.log('[MikomiContainer] Start re-arranging Mikomi object', this.Mikomi);

            // The format isn't easy to use for frontend setup,
            // so we adjust it here

            // Teamname is defined when importing keikaku data
            // from Excel sheets on frontend
            const teams = ['トイホビー', 'ゲーム開発'];
            this.ArrangedMikomi = [];

            for (let tIndex = 0; tIndex < teams.length; tIndex++)
            {
                const newTeam = new MikomiTeam(teams[tIndex]);

                const quarterData = [
                    new MikomiMonth(-1, 1, true, false),
                    new MikomiMonth(-1, 2, true, false),
                    new MikomiMonth(-1, 3, true, false),
                    new MikomiMonth(-1, 4, true, false)
                ];

                for (let i = 0; i < 12; i++)
                {
                    const monthData = new MikomiMonth(i + 1, -1, false, false);

                    // Gather data
                    for (let j = 0; j < this.Mikomi.length; j++)
                    {
                        const m = this.Mikomi[j];
                        if (m.Month === (i + 1))
                        {
                            let latestKeikaku = null;
                            let sagakuEstimation = null;
                            let sagakuResult = null;

                            for (let k = 0; k < m.Keikaku.length; k++)
                            {
                                const keikaku = m.Keikaku[k];

                                // Check if type is mikomi or keikaku
                                // mikomi does not have teamName
                                if (keikaku.teamName === newTeam.Name)
                                {
                                    let newKeikaku = null;
                                    for (let l = 0; l < monthData.Keikaku.length; l++)
                                    {
                                        if (monthData.Keikaku[l].Revision === keikaku.revision)
                                        {
                                            newKeikaku = monthData.Keikaku[l];
                                            break;
                                        }
                                    }

                                    if (newKeikaku === null)
                                    {
                                        newKeikaku = new MikomiKeikaku(keikaku.revision);
                                        monthData.Keikaku.push(newKeikaku);
                                    }

                                    newKeikaku.Data.sales_figures = keikaku.sales_figures;
                                    newKeikaku.Data.provProfit_figures = keikaku.provProfit_figures;

                                    newKeikaku.Data.sales_plastic = keikaku.sales_plastic;
                                    newKeikaku.Data.provProfit_plastic = keikaku.provProfit_plastic;

                                    newKeikaku.Data.sales_digital = keikaku.sales_digital;
                                    newKeikaku.Data.provProfit_digital = keikaku.provProfit_digital;

                                    newKeikaku.Data.sales_xpna = keikaku.sales_xpna;
                                    newKeikaku.Data.provProfit_xpna = keikaku.provProfit_xpna;

                                    newKeikaku.Data.sales = keikaku.sales;
                                    newKeikaku.Data.profit = keikaku.profit;
                                    newKeikaku.Data.provProfit = keikaku.provProfit;
                                    newKeikaku.Data.provProfit_rate = keikaku.sales !== 0 ? keikaku.provProfit/keikaku.sales * 100 : 0;
                                    newKeikaku.Data.operatingProfit = keikaku.operatingProfit;
                                    newKeikaku.Data.operatingProfit_rate = keikaku.sales !== 0 ? keikaku.operatingProfit/keikaku.sales * 100 : 0;
                                    newKeikaku.Data.netIncome = keikaku.netIncome ? keikaku.netIncome : 0;
                                    newKeikaku.Data.stock = keikaku.stock ? keikaku.stock : 0;

                                    if (latestKeikaku === null ||
                                        latestKeikaku.revision < keikaku.revision)
                                    {
                                        latestKeikaku = keikaku;
                                    }
                                }
                            }

                            for (let e = 0; e < m.Estimation.length; e++)
                            {
                                const estimation = m.Estimation[e];

                                if (estimation.teamName === newTeam.Name &&
                                    estimation.month === monthData.Month)
                                {
                                    monthData.Estimation.sales_figures = estimation.sales_figures ?? 0;
                                    monthData.Estimation.provProfit_figures = estimation.provProfit_figures ?? 0;
                                    monthData.Estimation.provProfit_rate_figures = estimation.sales_figures !== 0 ? estimation.provProfit_figures / estimation.sales_figures * 100 : 0;

                                    monthData.Estimation.sales_plastic = estimation.sales_plastic ?? 0;
                                    monthData.Estimation.provProfit_plastic = estimation.provProfit_plastic ?? 0;
                                    monthData.Estimation.provProfit_rate_plastic = estimation.sales_plastic !== 0 ? estimation.provProfit_plastic / estimation.sales_plastic * 100 : 0;

                                    monthData.Estimation.sales_digital = estimation.sales_digital ?? 0;
                                    monthData.Estimation.provProfit_digital = estimation.provProfit_digital ?? 0;
                                    monthData.Estimation.provProfit_rate_digital = estimation.sales_digital !== 0 ? estimation.provProfit_digital / estimation.sales_digital * 100 : 0;

                                    monthData.Estimation.sales_xpna = estimation.sales_xpna ?? 0;
                                    monthData.Estimation.provProfit_xpna = estimation.provProfit_xpna ?? 0;
                                    monthData.Estimation.provProfit_rate_xpna = estimation.sales_xpna !== 0 ? estimation.provProfit_xpna / estimation.sales_xpna * 100 : 0;

                                    // For toy team this will replace the sales_ttl
                                    monthData.Estimation.sales = (estimation.sales_games ?? 0) + (estimation.sales_ttl ?? 0);
                                    // For toy team this will replace the provProfit_ttl
                                    monthData.Estimation.provProfit = (estimation.provProfit_games ?? 0) + (estimation.provProfit_ttl ?? 0);
                                    monthData.Estimation.provProfit_rate = monthData.Estimation.sales !== 0 ? monthData.Estimation.provProfit / monthData.Estimation.sales * 100 : 0;

                                    monthData.Estimation.operatingProfit = null;
                                    monthData.Estimation.operatingProfit_rate = null;
                                    monthData.Estimation.netIncome = null;

                                    monthData.Estimation.stock = estimation.stock;

                                    sagakuEstimation = monthData.Estimation;
                                }
                            }

                            for (let r = 0; r < m.Result.length; r++)
                            {
                                const result = m.Result[r];

                                // We have to hardcode the separated groups
                                // inside toy-hobby
                                // Team names are a decided string at this point
                                // because those are decided and set at the backend.
                                if (result.month === monthData.Month)
                                {
                                    if (newTeam.Name === 'トイホビー' &&
                                        (result.teamName === 'トイホビー' ||
                                        result.teamName === 'プラモ' ||
                                        result.teamName === 'XPNA'))
                                    {
                                        if (result.teamName === 'トイホビー')
                                        {
                                            monthData.Result.sales_figures = result.sales;
                                            monthData.Result.provProfit_figures = result.provGrossOperatingProfit;
                                        }
                                        else if (result.teamName === 'プラモ')
                                        {
                                            monthData.Result.sales_plastic = result.sales;
                                            monthData.Result.provProfit_plastic = result.provGrossOperatingProfit;
                                        }
                                        else if (result.teamName === 'デジタル')
                                        {
                                            monthData.Result.sales_digital = result.sales;
                                            monthData.Result.provProfit_digital = result.provGrossOperatingProfit;
                                        }
                                        else if (result.teamName === 'XPNA')
                                        {
                                            monthData.Result.sales_xpna = result.sales;
                                            monthData.Result.provProfit_xpna = result.provGrossOperatingProfit;
                                        }

                                        monthData.Result.grossOperatingProfit += result.grossOperatingProfit;
                                        monthData.Result.netIncome += result.netIncome;
                                        monthData.Result.stock += result.stock;
                                        monthData.Result.teamName = 'トイホビー';
                                        monthData.Result.month = result.month;

                                        if (monthData.Month < this.CurrentMonth)
                                        {
                                            sagakuResult = monthData.Result;
                                        }
                                    }
                                    else if (result.teamName === newTeam.Name)
                                    {
                                        // console.log('assign result data just like that', result);
                                        monthData.Result = result;
                                        sagakuResult = monthData.Result;
                                    }
                                }
                                
                                // if (result.month === monthData.Month &&
                                //     result.teamName === newTeam.Name)
                                // {
                                //     monthData.Result = result;
                                //     sagakuResult = monthData.Result;
                                // }
                            }

                            // console.log('[MikomiContainer] Get difference for month ' + monthData.Month + ' for ' + newTeam.Name + ' from estimation: ' + (sagakuResult !== null) + '. If false, log contains sagaku', sagakuResult);
                            monthData.Difference = sagakuResult !== null ? this.GetDifferenceFromResult(latestKeikaku, sagakuResult) : this.GetDifferenceFromEstimation(latestKeikaku, sagakuEstimation);
                        }
                    }

                    if (i < 3)
                    {
                        this.AddMonthDataToQuarter(quarterData[0], monthData);
                    }
                    else if (i < 6)
                    {
                        this.AddMonthDataToQuarter(quarterData[1], monthData);
                    }
                    else if (i < 9)
                    {
                        this.AddMonthDataToQuarter(quarterData[2], monthData);
                    }
                    else if (i < 12)
                    {
                        this.AddMonthDataToQuarter(quarterData[3], monthData);
                    }

                    newTeam.Data.push(monthData);

                    // Push quarter info
                    if (i === 2)
                    {
                        quarterData[0].Estimation.stock = monthData.Estimation.stock;

                        let latestQKeikaku = new MikomiKeikaku(quarterData[0].Keikaku[quarterData[0].Keikaku.length - 1].revision);

                        for (let k = 0; k < quarterData[0].Keikaku.length; k++)
                        {
                            const qKeikaku = quarterData[0].Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        quarterData[0].Difference = this.CurrentMonth <= 3 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, quarterData[0].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, quarterData[0].Result);

                        newTeam.Data.push(quarterData[0]);
                    }
                    else if (i === 5)
                    {
                        quarterData[1].Estimation.stock = monthData.Estimation.stock;
                        
                        let latestQKeikaku = new MikomiKeikaku(quarterData[1].Keikaku[quarterData[1].Keikaku.length - 1].revision);

                        for (let k = 0; k < quarterData[1].Keikaku.length; k++)
                        {
                            const qKeikaku = quarterData[1].Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        quarterData[1].Difference = this.CurrentMonth <= 6 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, quarterData[1].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, quarterData[1].Result);
                        
                        newTeam.Data.push(quarterData[1]);
                    }
                    else if (i === 8)
                    {
                        quarterData[2].Estimation.stock = monthData.Estimation.stock;
                        
                        let latestQKeikaku = new MikomiKeikaku(quarterData[2].Keikaku[quarterData[2].Keikaku.length - 1].revision);

                        for (let k = 0; k < quarterData[2].Keikaku.length; k++)
                        {
                            const qKeikaku = quarterData[2].Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        quarterData[2].Difference = this.CurrentMonth <= 9 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, quarterData[2].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, quarterData[2].Result);
                        
                        newTeam.Data.push(quarterData[2]);
                    }
                    else if(i === 11)
                    {
                        quarterData[3].Estimation.stock = monthData.Estimation.stock;
                        
                        let latestQKeikaku = new MikomiKeikaku(quarterData[3].Keikaku[quarterData[3].Keikaku.length - 1].revision);

                        for (let k = 0; k < quarterData[3].Keikaku.length; k++)
                        {
                            const qKeikaku = quarterData[3].Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        quarterData[3].Difference = this.CurrentMonth <= 12 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, quarterData[3].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, quarterData[3].Result);
                        
                        newTeam.Data.push(quarterData[3]);
                    }

                    // Create kamiki or shimoki
                    if (i === 5)
                    {
                        const kamiki = new MikomiMonth(-1, 1, false, true);
                        this.AddQuarterDataToHalfYear(kamiki, quarterData[0]);
                        this.AddQuarterDataToHalfYear(kamiki, quarterData[1]);
                        kamiki.Estimation.stock = quarterData[1].Estimation.stock;
                        
                        let latestQKeikaku = new MikomiKeikaku(quarterData[1].Keikaku[quarterData[1].Keikaku.length - 1].revision);

                        for (let k = 0; k < kamiki.Keikaku.length; k++)
                        {
                            const qKeikaku = kamiki.Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        kamiki.Difference = this.CurrentMonth <= 6 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, kamiki.Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, kamiki.Result);
                        
                        newTeam.Data.push(kamiki);
                    }
                    else if (i === 11)
                    {
                        const shimoki = new MikomiMonth(-1, 2, false, true);
                        this.AddQuarterDataToHalfYear(shimoki, quarterData[2]);
                        this.AddQuarterDataToHalfYear(shimoki, quarterData[3]);
                        shimoki.Estimation.stock = quarterData[3].Estimation.stock;
                        
                        let latestQKeikaku = new MikomiKeikaku(quarterData[3].Keikaku[quarterData[3].Keikaku.length - 1].revision);

                        for (let k = 0; k < shimoki.Keikaku.length; k++)
                        {
                            const qKeikaku = shimoki.Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        shimoki.Difference = this.CurrentMonth <= 12 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, shimoki.Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, shimoki.Result);
                        
                        newTeam.Data.push(shimoki);
                    }

                    // Add ttl
                    if (i === 11)
                    {
                        const ttl = new MikomiMonth(-1, -1, false, false);
                        this.AddQuarterDataToHalfYear(ttl, quarterData[0]);
                        this.AddQuarterDataToHalfYear(ttl, quarterData[1]);
                        this.AddQuarterDataToHalfYear(ttl, quarterData[2]);
                        this.AddQuarterDataToHalfYear(ttl, quarterData[3]);

                        ttl.Estimation.stock = quarterData[3].Estimation.stock;

                        let latestQKeikaku = new MikomiKeikaku(quarterData[3].Keikaku[quarterData[3].Keikaku.length - 1].revision);

                        for (let k = 0; k < ttl.Keikaku.length; k++)
                        {
                            const qKeikaku = ttl.Keikaku[k];
                            // if (latestQKeikaku === null ||
                            //     latestQKeikaku.revision < qKeikaku.revision)
                            // {
                            //     latestQKeikaku = qKeikaku;
                            // }
                            latestQKeikaku.Data.Add(qKeikaku.Data);
                        }

                        ttl.Difference = this.CurrentMonth <= 12 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttl.Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttl.Result);
                        
                        newTeam.Data.push(ttl);
                    }
                }

                this.ArrangedMikomi.push(newTeam);
            }

            //
            // Create team total
            //
            const ttlTeam = new MikomiTeam('3部TTL');

            const ttlQuarterData = [
                new MikomiMonth(-1, 1, true, false),
                new MikomiMonth(-1, 2, true, false),
                new MikomiMonth(-1, 3, true, false),
                new MikomiMonth(-1, 4, true, false)
            ];

            for (let m = 1; m <= 12; m++)
            {
                const ttlMonth = new MikomiMonth(m, -1, false, false);

                for (let i = 0; i < this.ArrangedMikomi.length; i++)
                {
                    const teamData = this.ArrangedMikomi[i].Data;

                    for (let j = 0; j < teamData.length; j++)
                    {
                        const monthData = teamData[j];
                        if (monthData.Month === m)
                        {
                            // Sum estimation data
                            // console.log('check ttl estimation for month ' + m, ttlMonth.Estimation);
                            ttlMonth.Estimation.Add(monthData.Estimation);

                            // Go through each keikaku data for the current team
                            // and sum the keikaku data
                            for (let k = 0; k < monthData.Keikaku.length; k++)
                            {
                                const keikaku = monthData.Keikaku[k];

                                // Check if we have the keikaku already in ttlMonth.Keikaku
                                let ttlKeikaku = null;
                                for (let l = 0; l < ttlMonth.Keikaku.length; l++)
                                {
                                    if (ttlMonth.Keikaku[l].Revision === keikaku.Revision)
                                    {
                                        ttlKeikaku = ttlMonth.Keikaku[l];
                                        break;
                                    }
                                }

                                if (ttlKeikaku === null)
                                {
                                    ttlKeikaku = new MikomiKeikaku(keikaku.Revision);
                                    ttlMonth.Keikaku.push(ttlKeikaku);
                                }

                                // console.log('month check', monthData);
                                ttlKeikaku.Data.Add(keikaku.Data);
                            }

                            // Sum result data
                            // if (m >= 1 && m <= 3)
                            // {
                            //     console.log('add result to ttl', monthData.Result);
                            // }
                            ttlMonth.Result.Add(monthData.Result);

                            // console.log('3bu ttl month data sales',monthData.Result.sales);
                            // console.log('3bu ttl month data sales_figures',monthData.Result.sales_figures);
                            // console.log('3bu ttl month data plastic',monthData.Result.sales_plastic);
                            // console.log('3bu ttl month data xpna',monthData.Result.sales_xpna);
                            // ttlMonth.Result.sales = (isNaN(monthData.Result.sales) ? monthData.Result.sales : 0) + 
                            // monthData.Result.sales_figures + monthData.Result.sales_plastic + monthData.Result.sales_digital + monthData.Result.sales_xpna;
                        }
                    }
                }

                let latestKeikaku = null;
                for (let i = 0; i < ttlMonth.Keikaku.length; i++)
                {
                    if (latestKeikaku === null ||
                        latestKeikaku.revision < ttlMonth.Keikaku[i].Data.revision)
                    {
                        latestKeikaku = ttlMonth.Keikaku[i].Data;
                    }
                }

                // console.log('ttl keikaku', latestKeikaku);

                // console.log('[MikomiContainer] Get difference for month ' + ttlMonth.Month + ' for 3部TTL');

                ttlMonth.Difference = this.CurrentMonth > ttlMonth.Month ? this.GetDifferenceFromResult(latestKeikaku, ttlMonth.Result) : this.GetDifferenceFromEstimation(latestKeikaku, ttlMonth.Estimation);

                if (m < 4)
                {
                    // console.log('3Bu TTL Add to Q1', ttlMonth);
                    this.AddMonthDataToTTLQuarter(ttlQuarterData[0], ttlMonth);
                    // console.log('3bu ttl Q1 sales', ttlQuarterData[0].Estimation.sales);
                    // console.log('3bu ttl Q1 sales_figures', ttlQuarterData[0].Estimation.sales_figures);
                }
                else if (m < 7)
                {
                    this.AddMonthDataToQuarter(ttlQuarterData[1], ttlMonth);
                }
                else if (m < 10)
                {
                    this.AddMonthDataToQuarter(ttlQuarterData[2], ttlMonth);
                }
                else if (m < 13)
                {
                    this.AddMonthDataToQuarter(ttlQuarterData[3], ttlMonth);
                }

                // console.log('Add ttl month', ttlMonth);
                ttlTeam.Data.push(ttlMonth);

                // Push quarter info
                if (m === 3)
                {
                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[0].Keikaku[ttlQuarterData[0].Keikaku.length - 1].Revision);

                    for (let k = 0; k < ttlQuarterData[0].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[0].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    ttlQuarterData[0].Estimation.sales = ttlQuarterData[0].Estimation.sales_figures + ttlQuarterData[0].Estimation.sales_plastic + ttlQuarterData[0].Estimation.sales_digital + ttlQuarterData[0].Estimation.sales_xpna;

                    ttlQuarterData[0].Difference = this.CurrentMonth <= 3 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[0].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[0].Result);

                    // console.log('TTL Q1 estimation', ttlQuarterData[0].Estimation);
                    // console.log('TTL Q1 difference', ttlQuarterData[0].Difference);

                    ttlTeam.Data.push(ttlQuarterData[0]);
                }
                else if (m === 6)
                {
                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[1].Keikaku[ttlQuarterData[1].Keikaku.length - 1].Revision);

                    for (let k = 0; k < ttlQuarterData[1].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[1].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    ttlQuarterData[1].Estimation.sales = ttlQuarterData[0].Estimation.sales_figures + ttlQuarterData[1].Estimation.sales_plastic + ttlQuarterData[1].Estimation.sales_digital + ttlQuarterData[1].Estimation.sales_xpna;

                    ttlQuarterData[1].Difference = this.CurrentMonth <= 6 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[1].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[1].Result);

                    ttlTeam.Data.push(ttlQuarterData[1]);
                }
                else if (m === 9)
                {
                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[2].Keikaku[ttlQuarterData[2].Keikaku.length - 1].Revision);

                    for (let k = 0; k < ttlQuarterData[2].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[2].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    ttlQuarterData[2].Estimation.sales = ttlQuarterData[2].Estimation.sales_figures + ttlQuarterData[2].Estimation.sales_plastic + ttlQuarterData[2].Estimation.sales_digital + ttlQuarterData[2].Estimation.sales_xpna;

                    ttlQuarterData[2].Difference = this.CurrentMonth <= 9 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[2].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[2].Result);

                    ttlTeam.Data.push(ttlQuarterData[2]);
                }
                else if(m === 12)
                {
                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[3].Keikaku[ttlQuarterData[3].Keikaku.length - 1].Revision);

                    for (let k = 0; k < ttlQuarterData[3].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[3].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    ttlQuarterData[3].Estimation.sales = ttlQuarterData[3].Estimation.sales_figures + ttlQuarterData[3].Estimation.sales_plastic + ttlQuarterData[3].Estimation.sales_digital + ttlQuarterData[3].Estimation.sales_xpna;

                    ttlQuarterData[3].Difference = this.CurrentMonth <= 12 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[3].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[3].Result);

                    ttlTeam.Data.push(ttlQuarterData[3]);
                }

                // Create kamiki or shimoki
                if (m === 6)
                {
                    const kamiki = new MikomiMonth(-1, 1, false, true);
                    this.AddQuarterDataToHalfYear(kamiki, ttlQuarterData[0]);
                    this.AddQuarterDataToHalfYear(kamiki, ttlQuarterData[1]);
                    
                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[1].Keikaku[ttlQuarterData[1].Keikaku.length - 1].Revision);


                    for (let k = 0; k < ttlQuarterData[1].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[1].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    ttlQuarterData[1].Estimation.sales = ttlQuarterData[1].Estimation.sales_figures + ttlQuarterData[1].Estimation.sales_plastic + ttlQuarterData[1].Estimation.sales_digital + ttlQuarterData[1].Estimation.sales_xpna;

                    kamiki.Difference = this.CurrentMonth <= 6 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[1].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[1].Result);
                    // console.log('kamiki data', kamiki);
                    ttlTeam.Data.push(kamiki);
                }
                else if (m === 12)
                {
                    const shimoki = new MikomiMonth(-1, 2, false, true);
                    this.AddQuarterDataToHalfYear(shimoki, ttlQuarterData[2]);
                    this.AddQuarterDataToHalfYear(shimoki, ttlQuarterData[3]);
                    
                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[3].Keikaku[ttlQuarterData[3].Keikaku.length - 1].Revision);

                    for (let k = 0; k < ttlQuarterData[3].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[3].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    shimoki.Difference = this.CurrentMonth <= 12 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[3].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[3].Result);

                    ttlTeam.Data.push(shimoki);
                }

                if (m === 12)
                {
                    const ttl = new MikomiMonth(-1, -1, false, false);
                    this.AddQuarterDataToHalfYear(ttl, ttlQuarterData[0]);
                    this.AddQuarterDataToHalfYear(ttl, ttlQuarterData[1]);
                    this.AddQuarterDataToHalfYear(ttl, ttlQuarterData[2]);
                    this.AddQuarterDataToHalfYear(ttl, ttlQuarterData[3]);

                    let latestQKeikaku = new MikomiKeikaku(ttlQuarterData[3].Keikaku[ttlQuarterData[3].Keikaku.length - 1].revision);

                    for (let k = 0; k < ttlQuarterData[3].Keikaku.length; k++)
                    {
                        const qKeikaku = ttlQuarterData[3].Keikaku[k];
                        latestQKeikaku.Data.Add(qKeikaku.Data);
                    }

                    ttl.Difference = this.CurrentMonth <= 12 ? this.GetDifferenceFromEstimation(latestQKeikaku.Data, ttlQuarterData[3].Estimation, false) : this.GetDifferenceFromResult(latestQKeikaku.Data, ttlQuarterData[3].Result);

                    ttlTeam.Data.push(ttl);
                }
            }

            // console.log('3buTTL January estimation', ttlTeam.Data[0]);

            
            this.ArrangedMikomi.push(ttlTeam);
            console.log('arranged mikomi', this.ArrangedMikomi);
            this.$nextTick(()=>{
                this.IsCreatingMikomi = false;
            });
        },
        AddMonthDataToQuarter(quarter, monthData)
        {
            for (let j = 0; j < monthData.Keikaku.length; j++)
            {
                let found = false;
                for (let i = 0; i < quarter.Keikaku.length; i++)
                {
                    if (quarter.Keikaku[i].Revision === monthData.Keikaku[j].Revision)
                    {
                        found = true;
                        break;
                    }
                }

                if (found === false)
                {
                    quarter.Keikaku.push(new MikomiKeikaku(monthData.Keikaku[j].Revision));
                }
            }

            for (let j = 0; j < monthData.Keikaku.length; j++)
            {
                quarter.Keikaku[j].Data.Add(monthData.Keikaku[j].Data);
                quarter.Keikaku[j].Data.stock = monthData.Keikaku[j].Data.stock;
            }

            if (this.CurrentMonth > monthData.Month)
            {
                quarter.Estimation.Add(monthData.Result);
            }
            else
            {
                quarter.Estimation.Add(monthData.Estimation);
            }

            quarter.Result.Add(monthData.Result);
        },
        AddMonthDataToTTLQuarter(quarter, monthData)
        {
            for (let j = 0; j < monthData.Keikaku.length; j++)
            {
                let found = false;
                for (let i = 0; i < quarter.Keikaku.length; i++)
                {
                    if (quarter.Keikaku[i].Revision === monthData.Keikaku[j].Revision)
                    {
                        found = true;
                        break;
                    }
                }

                if (found === false)
                {
                    quarter.Keikaku.push(new MikomiKeikaku(monthData.Keikaku[j].Revision));
                }
            }

            for (let j = 0; j < monthData.Keikaku.length; j++)
            {
                quarter.Keikaku[j].Data.Add(monthData.Keikaku[j].Data);
                quarter.Keikaku[j].Data.stock = monthData.Keikaku[j].Data.stock;
            }

            if (this.CurrentMonth > monthData.Month)
            {
                quarter.Estimation.Add(monthData.Result);
            }
            else
            {
                // Because we are unfortunately summing the sales
                // in estimations, we have to separate them here
                // manually.
                // ToDo: Have dedicated sales_games
                const quarter_sales = quarter.Estimation.sales;
                const quarter_sales_figures = quarter.Estimation.sales_figures;
                const quarter_sales_plastic = quarter.Estimation.sales_plastic;
                const quarter_sales_digital = quarter.Estimation.sales_digital;
                const quarter_sales_xpna = quarter.Estimation.sales_xpna;

                quarter.Estimation.Add(monthData.Estimation);

                quarter.Estimation.sales = quarter_sales;
                quarter.Estimation.sales_figures = quarter_sales_figures + (monthData.Estimation.sales_figures ?? 0);
                quarter.Estimation.sales_plastic = quarter_sales_plastic + (monthData.Estimation.sales_plastic ?? 0);
                quarter.Estimation.sales_digital = quarter_sales_digital + (monthData.Estimation.sales_digital ?? 0);
                quarter.Estimation.sales_xpna = quarter_sales_xpna + (monthData.Estimation.sales_xpna ?? 0);
            }

            quarter.Result.Add(monthData.Result);
        },
        AddQuarterDataToHalfYear(halfYear, quarter)
        {
            for (let j = 0; j < quarter.Keikaku.length; j++)
            {
                let found = false;
                for (let i = 0; i < halfYear.Keikaku.length; i++)
                {
                    if (halfYear.Keikaku[i].Revision === quarter.Keikaku[j].Revision)
                    {
                        found = true;
                        break;
                    }
                }

                if (found === false)
                {
                    halfYear.Keikaku.push(new MikomiKeikaku(quarter.Keikaku[j].Revision));
                }
            }

            for (let j = 0; j < quarter.Keikaku.length; j++)
            {
                halfYear.Keikaku[j].Data.Add(quarter.Keikaku[j].Data);
                halfYear.Keikaku[j].Data.stock = quarter.Keikaku[j].Data.stock;
            }
            
            if (quarter.Quarter === 1)
            {
                if (this.CurrentMonth > 3)
                {
                    halfYear.Estimation.Add(quarter.Result);
                }
                else
                {
                    halfYear.Estimation.Add(quarter.Estimation);
                }
            }
            else if (quarter.Quarter === 2)
            {
                if (this.CurrentMonth > 6)
                {
                    halfYear.Estimation.Add(quarter.Result);
                }
                else
                {
                    halfYear.Estimation.Add(quarter.Estimation);
                }
            }
            else if (quarter.Quarter === 3)
            {
                if (this.CurrentMonth > 9)
                {
                    halfYear.Estimation.Add(quarter.Result);
                }
                else
                {
                    halfYear.Estimation.Add(quarter.Estimation);
                }
            }
            else if (quarter.Quarter === 4)
            {
                if (this.CurrentMonth > 12)
                {
                    halfYear.Estimation.Add(quarter.Result);
                }
                else
                {
                    halfYear.Estimation.Add(quarter.Estimation);
                }
            }

            halfYear.Result.Add(quarter.Result);
        },
        GetDifferenceFromEstimation(keikaku, estimation, isMonth = true)
        {
            const debug = keikaku.teamName === 'ttl';
            if (debug === true)
            {
                console.log('[MikomiContainer] Sagaku from 見込/計画');
                console.log('[MikomiContainer](GetDifferenceFromEstimation) Keikaku', keikaku);
                console.log('[MikomiContainer](GetDifferenceFromEstimation) Estimation', estimation);
            }
            const diffData = new MikomiData();

            if (estimation === null)
            {
                estimation = new MikomiData();
            }

            diffData.sales_figures = estimation.sales_figures - (keikaku.sales_figures ?? 0);
            diffData.provProfit_figures = estimation.provProfit_figures - (keikaku.provProfit_figures ?? 0);
            diffData.provProfit_rate_figures = diffData.sales_figures !== 0 ? diffData.provProfit_figures / diffData.sales_figures * 100 : 0;

            diffData.sales_plastic = estimation.sales_plastic - (keikaku.sales_plastic ?? 0);
            diffData.provProfit_plastic = estimation.provProfit_plastic - (keikaku.provProfit_plastic ?? 0);
            diffData.provProfit_rate_plastic = diffData.sales_plastic !== 0 ? diffData.provProfit_plastic / diffData.sales_plastic * 100 : 0;

            diffData.sales_digital = estimation.sales_digital - (keikaku.sales_digital ?? 0);
            diffData.provProfit_digital = estimation.provProfit_digital - (keikaku.provProfit_digital ?? 0);
            diffData.provProfit_rate_digital = diffData.sales_digital !== 0 ? diffData.provProfit_digital / diffData.sales_digital * 100 : 0;

            diffData.sales_xpna = estimation.sales_xpna - (keikaku.sales_xpna ?? 0);
            diffData.provProfit_xpna = estimation.provProfit_xpna - (keikaku.provProfit_xpna ?? 0);
            diffData.provProfit_rate_xpna = diffData.sales_xpna !== 0 ? diffData.provProfit_xpna / diffData.sales_xpna * 100 : 0;

            // if (keikaku.sales === undefined)
            // {
            //     console.log('keikaku sales undefined', keikaku);
            // }

            // console.log(`est.sales ${estimation.sales} - keik.sales ${keikaku.sales}`);
            diffData.sales = estimation.sales - keikaku.sales;
            diffData.provProfit = estimation.provProfit - keikaku.provProfit;
            diffData.provProfit_rate = diffData.sales !== 0 ? diffData.provProfit / diffData.sales * 100 : 0;

            diffData.stock = estimation.stock - keikaku.stock;

            
            // We don't have values for the following while
            // making estimations
            if (isMonth === true)
            {
                diffData.operatingProfit = undefined;// estimation.operatingProfit - keikaku.operatingProfit;
                diffData.operatingProfit_rate = undefined;// diffData.sales !== 0 ? diffData.operatingProfit / diffData.sales * 100 : 0;
                diffData.netIncome = undefined;// estimation.netIncome - keikaku.netIncome;
                diffData.profit = undefined;// 0 - keikaku.profit;
            }
            else
            {
                diffData.operatingProfit = estimation.operatingProfit - keikaku.operatingProfit;
                diffData.operatingProfit_rate = diffData.sales !== 0 ? diffData.operatingProfit / diffData.sales * 100 : 0;
                diffData.netIncome = estimation.netIncome - keikaku.netIncome;
                diffData.profit = undefined;// 0 - keikaku.profit;
            }
            

            return diffData;
        },
        GetDifferenceFromResult(keikaku, result)
        {
            // const debug = keikaku.teamName === 'ゲーム開発';
            // if (debug === true)
            // {
            //     console.log('[MikomiContainer] Sagaku from 実績/計画');
            //     console.log('[MikomiContainer](GetDifferenceFromResult) Keikaku', keikaku);
            //     console.log('[MikomiContainer](GetDifferenceFromResult) Jisseki/Result', result);
            // }

            const diffData = new MikomiData();

            for (const key in keikaku)
            {
                // console.log(`Key: ${key}  Result-Value: ${result[key]} Keikaku-Value: ${keikaku[key]}`);
                diffData[key] = result[key] - keikaku[key];
            }

            // We have to manually calculate the 総益 because
            // the names aren't the same...
            if (keikaku.teamName === 'ゲーム開発')
            {
                diffData.provProfit = result.provGrossOperatingProfit - keikaku.provProfit;
            }
            else
            {
                diffData.grossOperatingProfit = result.grossOperatingProfit - keikaku.provProfit;
            }
            
            // if (debug === true)
            // {
            //     console.log('Difference result', diffData);
            // }

            return diffData;
        },
        IsFiltered(monthData)
        {
            if (monthData.Month >= 1 && monthData.Month <= 12)
            {
                return this.IsMonthFiltered();
            }
            else if (monthData.IsQuarter === true)
            {
                return this.IsQuarterFiltered();
            }
            else if (monthData.IsHalfYear === true)
            {
                return this.IsHalfYearFiltered();
            }
            else
            {
                return true;
            }
        },
        IsMonthFiltered()
        {
            return this.FilteredTimeLine.some(item => item.label.includes('月'));
        },
        IsQuarterFiltered()
        {
            return this.FilteredTimeLine.some(item => item.label.includes('Q'));
        },
        IsHalfYearFiltered()
        {
            return this.FilteredTimeLine.some(item => item.label.includes('上期') || item.label.includes('下期'));
        },
    },
    data(){
        return{
            IsCreatingMikomi: false,
            ArrangedMikomi: null,
            CurrentMonth: 1,
        }
    }
}
</script>